import { createRoot } from "react-dom/client";
import App from "./App";
import "./global.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

// NOTE: React StrictMode intentionally double-invokes effects in development.
// For a WebGL app that creates Pixi/Three contexts inside an effect, that means
// two GL contexts get spun up and torn down on the first mount — which churns
// the canvas and trips Pixi's async teardown. We render without StrictMode so
// the engine boots exactly once. (The effect cleanup below is still correct for
// real unmounts / HMR.)
createRoot(rootEl).render(<App />);
